<template>
  <div>
    <van-cell-group v-for="(record, idx) in history" :key="idx" inset style="margin-top: 10px">
      <van-cell is-link center @click="review(record.id)">
        <template #title>{{ record.submit_time }}</template>
        <template #label>
          <div v-for="(item, index) in record.itemList" :key="item.id">
            <div v-if="index <= 1">{{ item.title }} : {{ item.valueText }}</div>
          </div>
          <div>...</div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-empty v-if="empty" description="暂无提交记录" style="margin-top: 20vh" />
  </div>
</template>

<script>
import request from "@/utils/RequestWithVant";
import { getItemValueText } from "@/utils/FormUtils.js";
import deepClone from "@/utils/DeepClone.js";
import uuid from "@/utils/UUID";

export default {
  components: {},
  props: ["id"],
  data() {
    return {
      history: [],
      empty: false,
    };
  },
  created() {
    this.getHistory();
  },
  methods: {
    getHistory() {
      request
        .showLoading()
        .get(
          "./api/collect/getSubmitHistory/" +
            this.id +
            "?clientId=" +
            this.getClientId()
        )
        .then((res) => {
          let list = res.data;
          for (var j = 0; j < list.length; j++) {
            let obj = list[j];
            try {
              let originalJSON = JSON.parse(obj.original_data);
              let itemList = originalJSON.itemList;
              for (var i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                item.valueText = getItemValueText(deepClone(item));
              }
              obj.itemList = itemList;
            } catch (error) {
              console.error(error);
            }
          }
          this.history = list;
          if (this.history && this.history.length == 1) {
            // 只有一条时用replace方式跳转
            this.$router.replace({
              path:
                "/form/" +
                this.id +
                "?mode=review&sid=" +
                this.history[0].id +
                "&self=t",
            });
          }
          if (this.history && this.history.length == 0) {
            this.empty = true;
          }
        });
    },
    getClientId() {
      let clientId = localStorage.getItem("idata_client_id");
      if (!clientId) {
        clientId = uuid();
        localStorage.setItem("idata_client_id", clientId);
      }
      return clientId;
    },
    review(id) {
      this.$router.push({
        path: "/form/" + this.id + "?mode=review&sid=" + id + "&self=t",
      });
    },
  },
};
</script>
<style scoped>
</style>